import { BehaviorSubject } from 'rxjs';

import { Injectable } from '@angular/core';
import { BreakpointService } from '@libs/breakpoints';

export type BreakpointMin = {
    isMobile: boolean;
    isMobileLarge: boolean;
    isTablet: boolean;
    isDesktop: boolean;
    isFull: boolean;
    isDesktopOrLarger: boolean;
    isTabletOrSmaller: boolean;
};

/**
 * Provides booleans for checking different breakpoints without needing to make array searches
 * For reference of each range width check the app.module.ts BreakpointModule configuration
 */
@Injectable({
    providedIn: 'root'
})
export class BreakpointMinService {
    private breakpointSubject$ = new BehaviorSubject<BreakpointMin>({
        isMobile: false,
        isMobileLarge: false,
        isTablet: false,
        isDesktop: false,
        isFull: false,
        isDesktopOrLarger: false,
        isTabletOrSmaller: false
    });

    public breakpoint$ = this.breakpointSubject$.asObservable();

    constructor(private breakpointService: BreakpointService) {
        this.breakpointService.breakpoint$.subscribe(breakpoints => {
            const isMobile = breakpoints.some(({ name }) => name === 'mobile');
            const isMobileLarge = breakpoints.some(({ name }) => name === 'mobile-large');
            const isTablet = breakpoints.some(({ name }) => name === 'tablet');
            const isDesktop = breakpoints.some(({ name }) => name === 'desktop');
            const isFull = breakpoints.some(({ name }) => name === 'full');
            const isDesktopOrLarger = breakpoints.some(({ name }) => name === 'desktop' || name === 'full');
            const isTabletOrSmaller = !isDesktopOrLarger;
            this.breakpointSubject$.next({
                isMobile,
                isMobileLarge,
                isTablet,
                isDesktop,
                isFull,
                isDesktopOrLarger,
                isTabletOrSmaller
            });
        });
    }
}
